import React, { Component } from 'react';
import { render } from 'react-dom';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import {useState, useEffect } from "react";

import "assets/css/chart.css";

let axios = require('axios');
let URL_API = "https://xs458763.xsrv.jp/api/";

function RankingChart(props){

	let session = JSON.parse(window.sessionStorage.getItem('sessions'));
	if(!session)
	    window.location = '/';

	// console.log(props);

	// const month = ["January","February","March","April","May","June","July","August","September","October","November","December"];
	const month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
	
	const weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

	// const flag			 						= props.flag;
	const [categories, setCategories] 			= useState([]);
	const [data, setData] 						= useState([]);

	const [seriesName, setSeriesName] 			= useState(props.item['title'] || '');
	const [uFlag, setUFlag] = useState(false);
	
	let cnt = 0;
	let sum = 0;
	let ave = 0;
	let min = 0;
	let max = 0;
	let dmin = '';
	let dmax = '';

	const setStateDatas = (d_datas) => {
		var categs = [];
		var dats = [];

		for(let ky in d_datas){
			categs.push(ky);
			dats.push(Number(d_datas[ky]));
		}
		
		setCategories(categs);
		// console.log(dats, categs);
		setData(dats);
	}

	const chartOptions = {
		xAxis: {
  			categories: categories,
  			title:'',
  			labels:{
  				enabled:true
  			}
  		},
  		yAxis:{
  			title:""
  		},
  		series: [
      		{ 
      			type: 'line',
      			name: seriesName,
        		data: data,
	          	color: '#0071ce',        		
      		}
		],
		credits: {
    		enabled: false
  		},
		tooltip: {
	        enabled: false,
	    },
		title:{
			text:''
		},
		plotOptions:{
			column: {
				pointPadding: 0.2,
				borderWidth: 0,
			},
		},
		chart:{
			height:120
		}
	}

	useEffect(() => {
		// console.log(props);
		axios.post(URL_API+"getAllRankingsAPI", {
	      params: {
	        user: props.player['id'], 
	        item_id:props.item.id
	      }
	    })
	    .then(function (response) {
	      if(Object.keys(response.data).length > 0 && typeof response.data == 'object'){
	        setStateDatas(response.data);
	        
	      }
	    }); 

  	}, []);
	return (
		<>  
      		<div className="chart_body">
				<div className="row col-12 px-0 mx-0 py-1 justify-content-between align-items-center">
					<div className="col-8 px-0 d-flex align-items-center">
						<div className="col-9 px-0 justify-content-start align-items-center">
							{seriesName}
						</div>
					</div>
				</div>
			</div>
			<div style={{borderBottom:'1px solid #000'}}>
        		<HighchartsReact
          			highcharts={Highcharts}
          			options={chartOptions}
        		/>
      		</div>
      	</>
    )
}

export default RankingChart;